module.exports = __webpack_public_path__ + "static/img/ent-detail-21.001cc32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-21.jpg
// module id = 7ntt
// module chunks = 51